var React = require('react');

function WaveLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M34.1834 -112.751C18.6834 -12 24.1834 17 49.6834 87C75.1834 157 16.5126 218.294 2.51265 311.48C-11.4874 404.667 62.0126 417.023 75.5126 509.18C89.0126 601.337 5.49295 567.5 31.1833 704.5C55.1784 832.459 -231.001 684.39 -268.875 664.29C-271.464 662.916 -272.987 660.264 -272.987 657.333V-21.1416C-272.987 -23.99 -271.534 -26.5871 -269.061 -28.0013C-232.379 -48.9823 48.6736 -206.938 34.1834 -112.751Z","fill":"#3C5DFF"}));
}

WaveLeft.defaultProps = {"width":"77","height":"659","viewBox":"0 0 77 659","fill":"none"};

module.exports = WaveLeft;

WaveLeft.default = WaveLeft;
